import valid from 'card-validator';
import * as regex from '../constants/regex';

export default (options: any) => {
  const {
    name,
    value,
    valueMatch,
    isRequired,
    error = 'Input is invalid.',
  } = options;

  const basicRequiredInputs = [
    'nameOnCard',
    'accountType',
    'accountOwnerName',
    'billingStreetAddress',
    'billingCity',
    'billingState',
    'driversLicenseState',
  ];

  if (basicRequiredInputs.indexOf(name) !== -1) {
    if (value === '' && isRequired) {
      return error;
    }
  } else if (name === 'routingNumber') {
    if (value === '' && isRequired) {
      return 'Routing number is required.';
    }
    if (value.length !== 9 && value !== '') {
      return 'Routing number is invalid.';
    }
  } else if (name === 'cardNumber') {
    const cardNumber = valid.number(value);
    if (value === '' && isRequired) {
      return 'Card number is required.';
    }
    if (!cardNumber.isValid) {
      return 'Card number is invalid.';
    }
  } else if (name === 'expiryDate') {
    if (value === null && isRequired) {
      return 'Expiry date is required.';
    }
  } else if (name === 'cvc') {
    if (value === '' && isRequired) {
      return 'CVC is required.';
    }
    if (value.length !== 3 && value.length !== 4 && isRequired) {
      return 'CVC is invalid.';
    }
  } else if (name === 'accountNumber') {
    if (value === '' && isRequired) {
      return 'Account number is required.';
    }
    if ((value.length < 4 || value.length > 17) && value !== '') {
      return 'Account number is invalid.';
    }
  } else if (name === 'accountNumberConfirm') {
    if (value === '' && isRequired) {
      return 'Account number confirmation is required.';
    }
    if ((value.length < 4 || value.length > 17) && value !== '') {
      return 'Account number confirmation is invalid.';
    }
    if (value !== '' && valueMatch !== '' && value !== valueMatch) {
      return 'Account number must match account number confirmation.';
    }
  } else if (name === 'billingZip') {
    if (value === '' && isRequired) {
      return 'Zip is required.';
    }
    if ((regex.alphaNumericSpaceDash.test(value) === false || value.length < 4 || value.length > 12) && value !== '') {
      return 'Zip is invalid.';
    }
  } else if (name === 'driversLicenseNumber') {
    if (value === '' && isRequired) {
      return 'DL Number is required.';
    }
    if ((regex.alphaNumericSpaceDash.test(value) === false || value.length < 1 || value.length > 50) && value !== '') {
      return 'DL Number is invalid.';
    }
  }
  return false;
};
